<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 125 124" fill="none">
    <rect x="89.5898" y="36" width="9.38797" height="63.4773" rx="4.5" transform="rotate(45 89.5898 36)" :fill="iconColor"/>
    <rect x="58.0454" y="80.5859" width="9.38797" height="32.3957" rx="4.5" transform="rotate(135 58.0454 80.5859)" :fill="iconColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M120.5 62C120.5 94.0325 94.5325 120 62.5 120C30.4675 120 4.5 94.0325 4.5 62C4.5 29.9675 30.4675 4 62.5 4C94.5325 4 120.5 29.9675 120.5 62ZM124.5 62C124.5 96.2417 96.7417 124 62.5 124C28.2583 124 0.5 96.2417 0.5 62C0.5 27.7583 28.2583 0 62.5 0C96.7417 0 124.5 27.7583 124.5 62Z" fill="#FFB600"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconCheckCircle",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
